export class ProductsTotalsRequest {

    ProductIDs: Array<number>;
    Date: Date;
}
